import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import Home from "./views/Home";
// LandingPage is the previous homepage — commented out in favor of HomeBeta (see routes below).
// import LandingPage from "./views/LandingPage";
import HomeBeta from "./views/HomeBeta";
import HomeV2 from "./views/HomeV2";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import VerifyEmail from "./views/VerifyEmail";
import SubmitDispute from "./views/SubmitDispute";
import Checkout from "./views/Checkout";
import StakeMatch from "./views/StakeMatch";
import ConnectReturn from "./views/ConnectReturn";
import DisputeView from "./views/DisputeView";
import DisputeResponse from "./views/DisputeResponse";
import DisputeEvidence from "./views/DisputeEvidence";
import AllDisputes from "./views/AllDisputes";
import AdminDisputes from "./views/AdminDisputes";
import AdminUsers from "./views/AdminUsers";
import AdminUserEdit from "./views/AdminUserEdit";
import AdminUserStripe from "./views/AdminUserStripe";
import AdminConfig from "./views/AdminConfig";
import AdminPrompts from "./views/AdminPrompts";
import PublicDisputes from "./views/PublicDisputes";
import Communities from "./views/Communities";
import About from "./views/About";
import Privacy from "./views/Privacy";
import Terms from "./views/Terms";
const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();

  if (loading) return <div style={styles.loading}>Loading...</div>;
  if (!token) return <Navigate to="/login" />;

  return children;
};

function AppRoutes() {
  const { token } = useAuth();

  return (
    <Routes>
      {/* <Route path="/" element={<LandingPage />} /> */}
      {/* <Route path="/home" element={<LandingPage />} /> */}
      <Route path="/" element={<HomeBeta />} />
      <Route path="/home" element={<HomeBeta />} />
      <Route path="/home-2" element={<HomeV2 />} />
      <Route path="/communities" element={<Communities />} />
      <Route path="/disputes" element={<PublicDisputes />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/login" element={token ? <Navigate to="/submit-dispute" /> : <Home />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/verify-email/:token" element={<VerifyEmail />} />
      <Route path="/dispute/:uuid" element={<DisputeView />} />
      <Route path="/dispute-evidence/:uuid" element={<DisputeEvidence />} />
      <Route path="/dispute-response/:uuid" element={<DisputeResponse />} />
      <Route path="/match-stake/:uuid" element={<StakeMatch />} />
      <Route
        path="/connect/return"
        element={
          <ProtectedRoute>
            <ConnectReturn />
          </ProtectedRoute>
        }
      />
      <Route
        path="/submit-dispute"
        element={
          <ProtectedRoute>
            <SubmitDispute />
          </ProtectedRoute>
        }
      />
      <Route
        path="/checkout/:uuid"
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
      />
      {/* Legacy /dashboard path — redirect to the new submission flow. */}
      <Route path="/dashboard" element={<Navigate to="/submit-dispute" replace />} />
      <Route
        path="/all-disputes"
        element={
          <ProtectedRoute>
            <AllDisputes />
          </ProtectedRoute>
        }
      />
      <Route path="/admin" element={<AdminDisputes />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/users/:userId/edit" element={<AdminUserEdit />} />
      <Route path="/admin/stripe/user/:userId" element={<AdminUserStripe />} />
      <Route path="/admin/config" element={<AdminConfig />} />
      <Route path="/admin/prompts" element={<AdminPrompts />} />
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

const styles = {
  loading: {
    height: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    fontFamily: "'JetBrains Mono', monospace", background: "#F4F4F0"
  }
};
